import { render, staticRenderFns } from "./ApiLookupBodyFormSection.vue?vue&type=template&id=a8ab1e48&scoped=true&"
import script from "./ApiLookupBodyFormSection.vue?vue&type=script&lang=js&"
export * from "./ApiLookupBodyFormSection.vue?vue&type=script&lang=js&"
import style0 from "./ApiLookupBodyFormSection.vue?vue&type=style&index=0&id=a8ab1e48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ab1e48",
  null
  
)

export default component.exports